import React from "react";

/**
 * Modal for displaying sale notes with proper formatting
 * @param {string} note - The note text to display
 * @param {boolean} isOpen - Whether the modal is open
 * @param {function} onClose - Function to call to close the modal
 */
const NoteModal = ({ note, isOpen, onClose }) => {
  if (!isOpen) return null;

  // Style definitions
  const styles = {
    noteModalBackdrop: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 999,
    },
    noteModal: {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "white",
      padding: "20px",
      borderRadius: "8px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      zIndex: 1000,
      maxWidth: "80%",
      maxHeight: "80%",
      overflow: "auto",
      color: "#333333",
    },
    closeButton: {
      position: "absolute",
      top: "10px",
      right: "10px",
      background: "none",
      border: "none",
      fontSize: "18px",
      cursor: "pointer",
      color: "#333333",
    },
    modalContent: {
      marginTop: "40px", // Add space below the close button
    },
    // Add styles for note content with preserved formatting
    noteText: {
      whiteSpace: "pre-wrap", // This preserves line breaks and spaces
      fontFamily: "inherit",
      fontSize: "14px",
      lineHeight: "1.6",
      margin: "12px 0",
    },
    header: {
      fontSize: "18px",
      fontWeight: "600",
      marginBottom: "16px",
      color: "#1e293b",
    },
  };

  return (
    <>
      <div style={styles.noteModalBackdrop} onClick={onClose} />
      <div style={styles.noteModal}>
        <button onClick={onClose} style={styles.closeButton}>
          CLOSE
        </button>
        <div style={styles.modalContent}>
          <h3 style={styles.header}>Note Details</h3>
          {/* Use pre-wrap to preserve line breaks */}
          <div style={styles.noteText}>{note}</div>
        </div>
      </div>
    </>
  );
};

export default NoteModal;
